/* eslint-disable max-len */
import ConditionColorizer from "./ConditionColorizer.js";
import ConditionColorizerEditor from "./ConditionColorizerEditor.js";
const install = molten => {
  molten.addPlugin('Model', {
    type: ConditionColorizer.TYPE,
    model: ConditionColorizer
  });
  molten.addPlugin('ModelEditor', {
    type: ConditionColorizer.TYPE,
    editor: ConditionColorizerEditor
  });
  molten.addPlugin('Colorizer', {
    type: ConditionColorizer.TYPE,
    name: 'Conditional Color',
    colorizer: ConditionColorizer
  });
};
export default {
  install
};